import ScalarIconNotepad_vue_vue_type_script_setup_true_lang_default from "./ScalarIconNotepad.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconNotepad.vue
var ScalarIconNotepad_default = ScalarIconNotepad_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconNotepad_default as default };

//# sourceMappingURL=ScalarIconNotepad.js.map